import React from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

function AssessmentQuizResult() {
  const navigate = useNavigate();

  const resultData = {
    score: 33.33,
    correctAnswers: 1,
    totalQuestions: 3,
    duration: 10,
    attempt: 3
  };

  const handleRedirect = () => {
    navigate('/user/classroom');
  };

  return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-100">
        <div className="p-4">
          {/* Header */}
          <div className="text-center mb-4">
            <h4 className="mb-1">Quiz Result</h4>
            <p className="text-gray-500 mb-0">Here's how you performed</p>
          </div>

          {/* Score Circle */}
          <div className="flex justify-center mb-5">
            <div 
              className="rounded-full border-4 border-primary flex flex-col items-center justify-center"
              style={{ width: '150px', height: '150px' }}
            >
              <h3 className="mb-0">{resultData.score}%</h3>
              <span className="text-gray-500">Score</span>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-12 gap-4 mb-4">
            {/* Correct Answers */}
            <div className="col-span-12 md:col-span-4">
              <div className="bg-gray-100 rounded p-4 text-center h-full">
                <div className="flex items-center justify-center mb-2">
                  <Icon 
                    icon="mdi:check-circle" 
                    className="text-green-500"
                    width="24" 
                    height="24" 
                  />
                </div>
                <h5 className="mb-1">Correct Answers</h5>
                <p className="mb-0 text-primary font-medium">
                  {resultData.correctAnswers}/{resultData.totalQuestions}
                </p>
              </div>
            </div>

            {/* Duration */}
            <div className="col-span-12 md:col-span-4">
              <div className="bg-gray-100 rounded p-4 text-center h-full">
                <div className="flex items-center justify-center mb-2">
                  <Icon 
                    icon="mdi:clock-outline" 
                    className="text-yellow-500"
                    width="24" 
                    height="24" 
                  />
                </div>
                <h5 className="mb-1">Duration</h5>
                <p className="mb-0 text-primary font-medium">
                  {resultData.duration} min
                </p>
              </div>
            </div>

            {/* Attempt */}
            <div className="col-span-12 md:col-span-4">
              <div className="bg-gray-100 rounded p-4 text-center h-full">
                <div className="flex items-center justify-center mb-2">
                  <Icon 
                    icon="mdi:refresh" 
                    className="text-blue-500"
                    width="24" 
                    height="24" 
                  />
                </div>
                <h5 className="mb-1">Attempt</h5>
                <p className="mb-0 text-primary font-medium">
                  #{resultData.attempt}
                </p>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div className="flex justify-center">
            <button 
              className="bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 w-full md:w-1/4"
              onClick={handleRedirect}
            >
              <Icon icon="mdi:refresh" width="20" height="20" />
                Redirect to Assessment
            </button>
          </div>
        </div>
      </div>
  );
}

export default AssessmentQuizResult; 